import titlize from 'titlize'

const SUBSTITUTIONS = new Map([
  [/^inputdata$/gi, 'Input Data'],
  [/^netCDF$/gi, 'NetCDF'],
  [/^ppn/gi, 'PPN'],
  [/^2d/gi, '2D'],
  [/^3d/gi, '3D'],
  [/^4d/gi, '4D'],
  [/^jpg/gi, 'JPG'],
  [/^png/gi, 'PNG']
])

const FULL_SUBSTITUTIONS = new Map([
  [/^Run_Section_ANU_PBS$/gi, 'Run Config'],
  [/^am_format$/gi, 'AM Format']
])

const NEEDS_UPPERCASE = [
  /^ced$/i,
  /^(x|y|z){1,3}$/i,
  /^(x|y|z|a){2,4}$/i,
  /^csv$/i,
  /^mdss$/i,
  /^CAC$/i,
  /^anu/i,
  /^FFT$/i,
  /^vtk$/i,
  /^gil$/i,
  /^ct$/i,
  /^vi0/i,
  /^mf/i,
  /^mpi/i,
  /^srm/i,
  /^jpg$/i,
  /^png$/i,
  /^tif/i,
  /^tiff/i,
  /^rgb/i,
  /^rgba/i,
  /^nc$/i,
  /^inr$/i,
  /^ldm$/i
]

export default function titleize (str) {
  if (str == null || str === '') return ''

  str = String(str).trim()
  // leave anything numeric as-is
  if (!Number.isNaN(Number(str))) return String(Number(str))

  FULL_SUBSTITUTIONS.forEach((value, key) => {
    str = str.replace(key, value)
  })

  str = str.replace(/_/g, ' ')
  str = titlize(str)

  str = str.split(' ')
    .map(word => {
      SUBSTITUTIONS.forEach((value, key) => {
        word = word.replace(key, value)
      })
      return word
    })
    .map(word => {
      NEEDS_UPPERCASE.forEach(regex => {
        if (!regex.test(word)) return
        word = word.toUpperCase()
      })
      return word
    })
    .join(' ')
  return str
}

titleize.datatype = (...args) => {
  return titleize(...args).replace(' Data', '')
}

export {
  titleize
}



// WEBPACK FOOTER //
// ../webmango-core/titleize.js